<div style="min-width: 40vw;">

    <!-- Form -->
    <form *ngIf="form" [formGroup]="form">

        <!-- Header -->
        <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary" style="margin: -24px;">
            <div class="text-lg font-medium">Asset</div>
            <button
                mat-icon-button
                (click)="close()"
                [tabIndex]="-1">
                <mat-icon
                    class="text-current"
                    [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>
        
        <div class="grid grid-cols-4 gap-4 w-full mt-4">
            <div class="col-span-4 grid grid-cols-12 gap-4 w-full mt-8" style="max-height: calc(100vh - 220px) !important; overflow-y: scroll; min-width: 270px; padding-right: 1px; margin-right: -1px;">
                
                <!-- Name -->
                <div class="col-span-12">
                    <mat-form-field
                        class="w-full"
                        [subscriptSizing]="'dynamic'">
                        <mat-label>Asset Name</mat-label>
                        <!-- <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:identification'"
                            matPrefix></mat-icon> -->
                        <input
                            [formControlName]="'name'"
                            matInput>
                    </mat-form-field>
                </div>

                <!-- Description -->
                <div class="col-span-12">
                    <mat-form-field
                        class="w-full"
                        [subscriptSizing]="'dynamic'">
                        <mat-label>Description</mat-label>
                        <!-- <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:pencil'"
                            matPrefix></mat-icon> -->
                        <textarea
                            style="max-height: 168px;"
                            [formControlName]="'description'"
                            matInput
                            [rows]="2"
                            cdkTextareaAutosize
                            [cdkAutosizeMinRows]="2">
                        </textarea>
                    </mat-form-field>
                </div>

                <!-- Category -->
                <div class="col-span-12 sm:col-span-6">
                    <mat-form-field
                        class="w-full"
                        [subscriptSizing]="'dynamic'">
                        <mat-label>Category</mat-label>

                        <input matInput [matAutocomplete]="auto"
                            [formControlName]="'categoryName'"
                            (input)="filterCategories($event)">
                        <mat-autocomplete #auto="matAutocomplete">
                            <mat-option *ngFor="let category of filteredCategories" [value]="category.title"
                                (onSelectionChange)="onCategorySelected(category)"
                            >
                                {{ category.title }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix class="text-[#0000008a] mr-[-0.4rem] cursor-pointer">arrow_drop_down</mat-icon>
                    </mat-form-field>
                </div>

                <!-- Supplier Dropdown -->
                <!-- <div class="col-span-6 w-full">
                    <mat-form-field
                        class="w-full"
                        [subscriptSizing]="'dynamic'">
                        <mat-label>Supplier</mat-label>
                        <mat-select
                            [formControlName]="'supplierId'"
                            disableOptionCentering
                            #roleSelect="matSelect">
                            <ng-container *ngFor="let supplier of suppliers">
                                <mat-option
                                    class="h-auto py-4 leading-none"
                                    [value]="supplier.supplierId">
                                    <div class="font-medium">{{supplier.name}}</div>
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div> -->
                
                <!-- Serial Number -->
                <div class="col-span-12 sm:col-span-6">
                    <mat-form-field
                        class="w-full"
                        [subscriptSizing]="'dynamic'">
                        <mat-label>Serial Number</mat-label>
                        <input
                            [formControlName]="'serialNumber'"
                            matInput>
                    </mat-form-field>
                </div>

                <!-- Location -->
                <div class="col-span-12 sm:col-span-6">
                    <mat-form-field
                        class="w-full"
                        [subscriptSizing]="'dynamic'">
                        <mat-label>Location</mat-label>
                        <input
                            [formControlName]="'location'"
                            matInput>
                    </mat-form-field>
                </div>

                <!-- Stock -->
                <!-- <div class="col-span-12 sm:col-span-4">
                    <mat-form-field
                        class="w-full"
                        [subscriptSizing]="'dynamic'">
                        <mat-label>Stock</mat-label>
                        <input
                            [formControlName]="'stock'"
                            matInput>
                    </mat-form-field>
                </div> -->
                <!-- Cost -->
                <!-- <div class="col-span-12 sm:col-span-4">
                    <mat-form-field
                        class="w-full"
                        [subscriptSizing]="'dynamic'">
                        <mat-label>Cost</mat-label>
                        <span matPrefix class="text-secondary">£</span>
                        <input
                            [formControlName]="'cost'"
                            matInput>
                    </mat-form-field>
                </div> -->

                <!-- Price -->
                <div class="col-span-12 sm:col-span-3">
                    <mat-form-field
                        class="w-full"
                        [subscriptSizing]="'dynamic'">
                        <mat-label>Daily Rate</mat-label>
                        <span matPrefix class="text-secondary">£</span>
                        <input
                            [formControlName]="'price'"
                            matInput>
                    </mat-form-field>
                </div>
                
                <!-- Standby Price -->
                <div class="col-span-12 sm:col-span-3">
                    <mat-form-field
                        class="w-full"
                        [subscriptSizing]="'dynamic'">
                        <mat-label>Standby Rate</mat-label>
                        <span matPrefix class="text-secondary">£</span>
                        <input
                            [formControlName]="'standbyPrice'"
                            matInput>
                    </mat-form-field>
                </div>

                <!-- Swimlane -->
                <div class="col-span-12 sm:col-span-8">
                    <mat-form-field
                        class="w-full"
                        [subscriptSizing]="'dynamic'">
                        <mat-label>Status</mat-label>
                        <mat-select
                            class="user-select"
                            [formControlName]="'swimlaneId'"
                            [panelClass]="'w-72 min-w-72 max-w-72 h-auto max-h-none'"
                            disableOptionCentering
                            #roleSelect="matSelect">
                            <ng-container *ngFor="let lane of swimlanes">
                                <mat-option
                                    class="h-auto py-4 leading-none"
                                    [value]="lane.id"
                                    [disabled]="isBasic">
                                    <div class="font-medium">{{lane.title}}</div>
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                
                <!-- Calibration Due -->
                <div class="col-span-12 sm:col-span-4">
                    <mat-form-field
                        class="w-full"
                        [subscriptSizing]="'dynamic'">
                        <mat-label>Calibration Due</mat-label>
                        <input
                            matInput
                            [matDatepicker]="calibrationDueDatepicker"
                            [formControlName]="'calibrationDueDate'"
                            [placeholder]="'Calibration Due'">
                        <mat-datepicker-toggle matSuffix [for]="calibrationDueDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #calibrationDueDatepicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <!-- Annual Service Required -->
                <div class="col-span-12 sm:col-span-8 flex items-center sm:toggle-height pl-2">
                    <mat-slide-toggle
                        [checked]="product.annualServiceRequired"
                        (change)="toggleService($event)"
                        [color]="'primary'">
                        <span class="ml-2">Annual Service Required</span>
                    </mat-slide-toggle>
                </div>
                
                <!-- Service Due -->
                <div *ngIf="product.annualServiceRequired" class="col-span-12 sm:col-span-4">
                    <mat-form-field
                        class="w-full"
                        [subscriptSizing]="'dynamic'">
                        <mat-label>Service Due</mat-label>
                        <input
                            matInput
                            [matDatepicker]="serviceDueDatepicker"
                            [formControlName]="'serviceDueDate'"
                            [placeholder]="'Service Due'">
                        <mat-datepicker-toggle matSuffix [for]="serviceDueDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #serviceDueDatepicker></mat-datepicker>
                    </mat-form-field>
                </div>

            </div>
        </div>

        <!-- Divider -->
        <div class="mt-8 mb-6 border-t"></div>

        <!-- Actions -->
        <div class="flex items-center justify-end">
            <button
                (click)="close()"
                mat-stroked-button
                type="button">
                Cancel
            </button>
            <button
                (click)="save()"
                class="ml-4"
                mat-flat-button
                type="button"
                [color]="'primary'"
                [disabled]="!form.valid || form.pristine">
                Save                
            </button>
        </div>
    </form>

</div>
